export const IS_NODE = process && !process.browser
export const IS_WEB = !IS_NODE && typeof document !== 'undefined'
export const IS_DEV = IS_NODE
  ? process.env.NODE_ENV === 'development'
  : /^(localhost|0\.0|192\.)/.test(window.location.hostname)
export const IS_SANDBOX = !IS_NODE && /^get-dev-/.test(window.location.hostname)
export const IS_PROD = IS_NODE ? process.env.NODE_ENV === 'production' : !IS_DEV

// TODO: read port from config for local..
let SITE_URL = IS_PROD
  ? `https://${IS_SANDBOX ? 'get-dev-8979.' : ''}snips.ai/`
  : 'http://localhost:5000/'
if (!IS_NODE) {
  SITE_URL = window.location.protocol + '//' + window.location.host + '/'
}
export { SITE_URL }

export const DOCS_URL = 'https://snips.gitbook.io/documentation/'
export const TERMS_CONDITIONS_URL = 'https://snips.ai/terms'

export const CONSOLE_BASE_URL =
  IS_PROD && !IS_SANDBOX
    ? 'https://console.snips.ai'
    : 'https://console-dev.snips.ai'
export const CONSOLE_URL = CONSOLE_BASE_URL + '/signup'
export const CONSOLE_LOGIN_URL = CONSOLE_BASE_URL + '/login'

export const MAKERS_URL = 'https://makers.snips.ai/'
export const ICO_URL = 'https://ico.snips.ai/'
export const TOKEN_SALE_URL = 'https://token.snips.ai/'
export const AIR_URL = 'https://air.snips.ai/'

export const DISCORD_LINK = 'https://discordapp.com/invite/3939Kqx'
export const FACEBOOK_LINK = 'https://www.facebook.com/snipscompany'
export const TWITTER_LINK = 'https://twitter.com/snips'
export const LINKEDIN_LINK = 'https://www.linkedin.com/company/snips'
export const INSTAGRAM_LINK = 'https://www.instagram.com/snips.ai/'

// NOTE: this url redirects to third part jobs site,
// specified via S3. Using absolute snips url here to avoid duplicating
// the exact redirect url
export const JOBS_URL = 'https://snips.ai/jobs'

export const COOKIES_TRACKING_CONSENT_COOKIE_NAME = 'snipsCookiesAndTracking'



// WEBPACK FOOTER //
// ./frontend/scripts/config/index.js